import http from '../../../utils/http';
import security from '../../../utils/security';
import {
  TRANSFERTYPE_LIST_ERROR,
  TRANSFERTYPE_LIST_LOADING,
  TRANSFERTYPE_LIST_RESET,
  TRANSFERTYPE_LIST_VIEW,
  TRANSFERTYPE_LIST_SUCCESS
} from './mutation-types';

const state = {
  loading: false,
  error: '',
  items: [],
  view: []
};

function error(error) {
  return {type: TRANSFERTYPE_LIST_ERROR, error};
}

function loading(loading) {
  return {type: TRANSFERTYPE_LIST_LOADING, loading};
}

function success(items) {
  return {type: TRANSFERTYPE_LIST_SUCCESS, items};
}

function view(items) {
  return { type: TRANSFERTYPE_LIST_VIEW, items};
}

const getters = {
  error: state => state.error,
  items: state => state.items,
  loading: state => state.loading,
  view: state => state.view
};

const actions = {
    getItems({ commit }, page = '/transfer_types') {
      commit(loading(true));
      commit(error(null));

      return http.fetch(page)
        .then(response => response.json())
        .then(data => {
          commit(loading(false));
          commit(success(data['hydra:member']));
          commit(view(data['hydra:view']));
        })
        .catch(e => {
          commit(loading(false));
          if(security.handleAuthorizationError(e)){
            return;
          }
          commit(error(e.message));
        });
    }
};

const mutations = {
    [TRANSFERTYPE_LIST_ERROR] (state, payload) {
      state.error = payload.error;
    },
    [TRANSFERTYPE_LIST_LOADING] (state, payload) {
      state.loading = payload.loading;
    },
    [TRANSFERTYPE_LIST_VIEW] (state, payload) {
      state.view = payload.items;
    },
    [TRANSFERTYPE_LIST_SUCCESS] (state, payload) {
      state.items = payload.items;
    },
    [TRANSFERTYPE_LIST_RESET] (state) {
      state.items = [];
    }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/transfertype/list.js